export default __webpack_public_path__ + "static/media/gallery_02.a4896e11.jpg";